import { render, staticRenderFns } from "./layout-registration.vue?vue&type=template&id=6218d4e2"
import script from "./layout-registration.vue?vue&type=script&lang=js"
export * from "./layout-registration.vue?vue&type=script&lang=js"
import style0 from "./layout-registration.vue?vue&type=style&index=0&id=6218d4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports